import { createGlobalStyle } from 'styled-components';
import devices from './devices';

export default createGlobalStyle`
    /* Gerais */
    body {
        font: 14px Roboto, sans-serif;
        font-weight: 400;
        -webkit-font-smoothing: antialised;
    }

    img {
      max-width: 100%;
    }

    .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
      font-weight: 800;
    }

    a {
      color: #000000;
      text-decoration: none;

      &:hover {
        color: rgb(75,78,95);
        text-decoration: underline;
      }
    }

    .spacer {
      margin-bottom: 2.2rem;
    }

    .btn.btn-primary {
        min-width: 180px;
        max-height: 50px;
        border-radius: 0;
        font-style: italic;
        text-transform: uppercase;
        color: #FFFFFF;
        border-color: #000000;
        background-color: #000000;
        text-decoration: none;

        padding-top: 10px;
        padding-bottom: 10px;

        @media ${devices.xs} {
          width: auto;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
    }

    .btn.btn-primary:hover, .btn.btn-primary:active, .btn.btn-primary:focus, .btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, .show>.btn-primary.dropdown-toggle, .btn-primary:not(:disabled):not(.disabled).active:focus, .btn-primary:not(:disabled):not(.disabled):active:focus, .show>.btn-primary.dropdown-toggle:focus {
        color: #000000;
        background-color: #FFFFFF;
        border-color: #000000;
        box-shadow: 0 0 0 0.2rem rgba(75,78,95,0.1);
    }

    .btn.focus, .btn:focus {
      outline: none;
      box-shadow: none;
    }

    .btn-sm {
      line-height: 1.2;
    }

    .form-group h5 {
        text-align: center;
        margin-bottom: 30px;
    }

    input.form-control, select.form-control, textarea.form-control {
        border-color: transparent;
        background-color: #F8F4F3;
        color: #495057;
        font-weight: 300 !important;
    }

    input[type=date].form-control {
      font-size: 13px;
    }

    option {
      font-weight: 300;
    }

    .footer-info {
        background-color: #E7E7E7;
        padding: 30px 0 25px 0;

        p {
          margin-bottom: 0;
        }
    }

    .col.certificate{
        margin-bottom: 5px;
    }


    /* Específicas */
    .form-group.head-text {
        margin-bottom: 50px;
        text-align: justify;
        margin: 10px 0 0 0;
    }

    .form-group.form-text {
        font-weight: 500;
    }

    .d-flex.justify-content-center.date p{
        padding: 0 10px 0 10px;
    }

    .d-flex.justify-content-center.date input {
        padding: 0 -5px 0 0;
    }

    .d-flex.justify-content-center.date img {
        max-width: 35px;
        max-height: 35px;
    }

    .d-flex.justify-content-around.img{
        padding: 0 50px 0 0;
    }

    .accordion {
      .card-header {
        background-color: #C9D7E2;
        border: none;

        button {
          color: #212529;
          font-size: 15px;
          padding: 0;

          &:focus {
            box-shadow: none;
          }
        }
      }

      .card {
        border: none;
        margin-bottom: 5px;
      }
    }

    .form-control:focus {
      border-color: #000;
      box-shadow: 0 0 0 0.2rem rgba(75,78,95,0.1);
    }

    .form-control-file.input {
        padding: 10px 0 10px 0;
    }

    .cifrao-img{
        margin-bottom: -10px;
        margin-top: -10px;
        padding-left: 20px;
    }

    .img-calendar {
        max-width: 40px;
        max-height: 40px;
        padding-left: 15px;
        margin-top: -10px;
        margin-bottom: -10px;
    }

    .img-pesquisa {
        max-width: 35px;
        max-height: 35px;
        margin-top: -10px;
        margin-bottom: -10px;
    }

    .table thead th {
        padding: .75rem;
        vertical-align: top;
        border-bottom: 1px solid #000000;
        border-top: 1px solid #000000;
    }
    .table th.icons, .table td.icons {
      padding: 4px;
    }

    .table tr {
      transition: all 1s;

      &.hide {
        display: none;
        height: 0;
      }
      &.show {
        display: auto;
        height: auto;
      }
    }

`;
